module.exports = __webpack_public_path__ + "media/Video 15a.267a9825.mp4";